import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiSettings, FiMoreVertical } from "react-icons/fi";
import styles from "./StaffTable.module.css";
import CreateStaffModal from "./modals/CreateStaffModal";
import { API_URL } from '../../config/api';

const StaffCurrent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [staff, setStaff] = useState([]);
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
  const [editingUser, setEditingUser] = useState(null); 

  const handleIconClick = (id, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const dropdownWidth = 100;
    const dropdownHeight = 80;

    let left = rect.right - dropdownWidth - 35;
    let top = rect.bottom;

    if (rect.bottom + dropdownHeight > window.innerHeight) {
      top = rect.top - dropdownHeight;
    }

    setDropdownPos({ top, left });
    setDropdownOpenId(dropdownOpenId === id ? null : id);
  };

  const fetchStaff = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      const saved = localStorage.getItem("staff");
      if (saved) setStaff(JSON.parse(saved));
      return;
    }

    try {
      const response = await axios.get(
        `${API_URL}/api/users?status=active`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200 && Array.isArray(response.data.data)) {
        const staffData = response.data.data.map((user) => ({
          id: user.id,
          name: `${user.name} ${user.surname}`,
          position: user.role,
          phone: user.phone,
          rawData: user, 
        }));
        setStaff(staffData);
        localStorage.setItem("staff", JSON.stringify(staffData));
      } else {
        const saved = localStorage.getItem("staff");
        if (saved) setStaff(JSON.parse(saved));
      }
    } catch (error) {
      console.error(error);
      const saved = localStorage.getItem("staff");
      if (saved) setStaff(JSON.parse(saved));
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const handleStaffCreated = (newStaffMember) => {
    const updatedStaff = [
      ...staff.filter((s) => s.id !== newStaffMember.id),
      {
        id: newStaffMember.id,
        name: `${newStaffMember.name} ${newStaffMember.surname}`,
        position: newStaffMember.role?.title || "",
        phone: newStaffMember.phone,
        rawData: newStaffMember,
      },
    ];
    setStaff(updatedStaff);
    localStorage.setItem("staff", JSON.stringify(updatedStaff));
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    if (!window.confirm("Вы действительно хотите удалить сотрудника?")) return;
    try {
      await axios.delete(`${API_URL}/api/users/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const updatedStaff = staff.filter((s) => s.id !== id);
      setStaff(updatedStaff);
      localStorage.setItem("staff", JSON.stringify(updatedStaff));
    } catch (error) {
      console.error(error);
      alert("Не удалось удалить сотрудника");
    }
  };

  const openEditModal = (user) => {
    setEditingUser(user);
    setIsModalOpen(true);
    setDropdownOpenId(null);
  };

  return (
    <div className={styles.container}>
      <button className={styles.add} onClick={() => { setEditingUser(null); setIsModalOpen(true); }}>+</button>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Имя</th>
              <th>Должность</th>
              <th>Телефон</th>
              <th><FiSettings size={18} /></th>
            </tr>
          </thead>
          <tbody>
            {staff.map((person) => (
              <tr key={person.id}>
                <td>{person.name}</td>
                <td>{person.position}</td>
                <td>{person.phone}</td>
                <td className={styles.iconCell}>
                  <div className={styles.dropdownWrapper}>
                    <FiMoreVertical
                      size={20}
                      style={{ cursor: "pointer" }}
                      onClick={(e) => handleIconClick(person.id, e)}
                    />
                    {dropdownOpenId === person.id && (
                      <div
                        className={styles.dropdown}
                        style={{ top: dropdownPos.top, left: dropdownPos.left, position: 'fixed' }}
                      >
                        <button
                          className={styles.dropdownBtn}
                          onClick={() => openEditModal(person.rawData)}
                        >
                          Редактировать
                        </button>
                        <button
                          className={styles.dropdownBtn}
                          onClick={() => handleDelete(person.id)}
                        >
                          Удалить
                        </button>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <CreateStaffModal
          onClose={() => {
            setIsModalOpen(false);
            fetchStaff(); // 🔹 обновляем таблицу после закрытия модалки
          }}
          onCreated={handleStaffCreated}
          user={editingUser}
          isEdit={!!editingUser}
        />
      )}
    </div>
  );
};

export default StaffCurrent;
